<template>
  <main class="activate-page" role="main">
    <vue-loading :active.sync="is_loading" :can-cancel="false" :is-full-page="true"></vue-loading>
    <div class="row">
      <div class="col-sm-12 col-md-6 col-lg-5 activate-section">
        <div class="container activate" v-if="!is_activated">
          <h1 class="section-title">Complete Activation</h1>
          <p
            class="text-normal"
          >Almost there, please complete the RICA information below to finalize activation</p>
          <div class="Document-upload">
            <label class="section-label">Documents</label>
            <div class="row">
              <div class="col-lg-6">
                <div class="form-group">
                  <label>Proof of Address</label>
                  <upload-btn
                    class="btn btn-dark btn-block"
                    :ripple="false"
                    title="Upload"
                    @file-update="address_file"
                  ></upload-btn>
                </div>
              </div>
              <div class="col-lg-6">
                <div class="form-group">
                  <label>Copy of {{subscriber.id_type}}</label>
                  <upload-btn
                    class="btn btn-dark btn-block"
                    :ripple="false"
                    title="Upload"
                    @file-update="id_file"
                  ></upload-btn>
                </div>
              </div>
            </div>
            <div class="error-message" v-if="uploads_error != ''">{{ uploads_error }}</div>
          </div>

          <vue-address-details
            :details.sync="address_details"
            :showInputs.sync="show_address_inputs"
            @updated:address="updateAddress"
            type="Residential"
            errorMessage="Street Address is required. Please type your residential street address for RICA."
          ></vue-address-details>
          <div class="error-message" v-if="address_error != ''">{{ address_error }}</div>

          <div class="reseller-code">
            <label class="section-label">Promo Code</label>
            <div class="form-group">
              <input
                type="text"
                name="promo_code"
                class="form-control"
                v-model="promo_code"
                placeholder="Promo Code"
              />
            </div>
          </div>
          <div class="error-message" v-if="error_message != ''">{{ error_message }}</div>
          <div class="page-controls mt-3">
            <div class="row no-gutters">
              <button
                type="button"
                class="col btn btn-outline-primary cancel"
                v-on:click="cancel"
              >Cancel</button>
              <button type="button" class="col btn btn-primary next" v-on:click="validate">
                Activate
                <i class="fa fa-chevron-right" aria-hidden="true"></i>
              </button>
            </div>
          </div>
        </div>
        <div class="container activate" v-if="is_activated">
          <h1 class="section-title">Activation Completed</h1>
          <p
            class="text-normal"
          >You may now use your me&amp;you sim. Your new number is: {{ msisdn }}</p>
        </div>
      </div>
      <div class="col-sm-12 col-md-6 col-lg-7 image-section">
        <img
          class="img-fluid"
          src="/assets/images/backgrounds/me-you-activation-image.jpg"
          alt="Acivation-Input-Image"
        />
      </div>
    </div>
  </main>
</template>

<script>
import SubscriberService from "@/services/subscriber.service.js";

import VueAddressDetails from "@/components/elements/vue-address-details";
import UploadButton from "vuetify-upload-button";

import AddressModel from "@/models/address.model";
import SubscriberModel from "@/models/subscriber.model";

export default {
  name: "reseller-activation",
  components: {
    "upload-btn": UploadButton,
    "vue-address-details": VueAddressDetails
  },
  data() {
    return {
      is_loading: false,
      error_message: "",
      address_error: "",
      uploads_error: "",
      sim_number: "",
      id_number: "",
      subscriber: new SubscriberModel(),
      address_details: new AddressModel(),
      show_address_inputs: false,
      files: [],
      promo_code: "",
      is_activated: false,
      msisdn: ""
    };
  },
  mounted() {
    var self = this;
    self.is_loading = true;
    self.sim_number = self.$route.query.iccid;
    self.id_number = self.$route.query.id;
    self.getCustomerBySimNumber();
  },
  methods: {
    getCustomerBySimNumber() {
      var self = this;
      SubscriberService.getSubscriberByIccid(self.sim_number, self.id_number)
        .then(response => {
          self.is_loading = false;
          self.$log.debug(response);
          if (response.data.success) {
            var data = response.data.data.subscriber;
            self.$scrollTo("body");
            self.mapSubscriberModel(data.customer);
            self.mapAddressModel(data.address);
            self.mapOrderModel(data.order);
            self.mapUploadModel(data.uploads);
          } else {
            self.error_message =
              "Unfortunately we cannot complete this request. Please contact support.";
          }
        })
        .catch(() => {
          self.is_loading = false;
          self.error_message =
            "Unfortunately we cannot complete this request. Please contact support.";
        });
    },
    updateAddress(address) {
      var self = this;
      self.address_details = address;
    },
    address_file(file) {
      var self = this;
      self.$log.debug("address file : " + file);
      self.files.push({ file: file, type: "address" });
    },
    id_file(file) {
      var self = this;
      self.$log.debug("id file : " + file);
      self.files.push({ file: file, type: "id" });
    },
    validate() {
      var self = this;
      self.error_message = "";
      self.uploads_error = "";
      self.address_error = "";
      self.$log.debug("validate");
      var has_errors = false;
      if (!self.address_details.is_valid) {
        self.address_error = "Invalid address. Please correct to Activate.";
        has_errors = true;
      }
      if (self.files.length < 2) {
        self.uploads_error =
          "Invalid uploads. Please upload all required documents.";
        has_errors = true;
      }
      if (!has_errors) {
        self.activate();
      } else {
        self.error_message = "Invalid inputs.";
      }
    },
    activate() {
      var self = this;
      self.is_loading = true;
      self.$log.debug("activate");
      self.$log.debug({
        sim: self.sim_number,
        sub: self.subscriber,
        add: self.address_details,
        files: self.files,
        promo: self.promo_code
      })
      SubscriberService.activate(
        self.sim_number,
        self.subscriber,
        self.address_details,
        self.files,
        self.promo_code,
        true
      )
        .then(response => {
          self.is_loading = false;
          self.$log.debug(response);
          if (response.data.success) {
            self.$scrollTo("body");
            var data = response.data.data;
            self.is_activated = true;
            self.msisdn = data.subscriber.msisdn;
            data.subscriber.is_partial = false;
            self.$emit('activated', data.subscriber)
          } else {
            self.error_message =
              "Unfortunately we cannot complete this request. Please contact support.";
          }
        })
        .catch((err) => {
          self.is_loading = false;
          self.$log.debug(err);
          self.error_message =
            "Unfortunately we cannot complete this request. Please contact support. Error";
        });
    },
    mapSubscriberModel(data) {
      var self = this;
      var model = {
        id: data.customer_id,
        first_name: data.firstname,
        last_name: data.lastname,
        mobile_number: data.telephone,
        email_address: data.email,
        id_type: data.id_type,
        id_number: data.id_number
      }
      self.$log.debug("Subscriber Model", model);
      self.subscriber = new SubscriberModel(model);
      self.$log.debug("Subscriber", self.subscriber);
    },
    mapAddressModel(data) {
      var self = this;
      var model = {
        building: data.address_2 != '' ? data.address_1 : "",
        combined_number_street: data.address_2 != '' ? data.address_2 : data.address_1,
        area: data.area,
        city: data.city,
        code: data.postcode,
        province: data.province,
        province_code: data.zone_id,
        country_code: data.country_id,
        instructions: data.delivery_instructions 
      }
      self.$log.debug("Address Model", model);
      self.address_details = new AddressModel(model);
      self.show_address_inputs = self.address_details.is_valid;
      self.$log.debug("Address", self.address_details);      
    },
    mapOrderModel(data){
      var self = this;
      self.promo_code = data.promo_code;
    },
    mapUploadModel(data) {
      var self = this;
      data.forEach(file => {
        self.files.push(file);
      });
    },
    cancel() {
      var self = this;
      self.$router.push("activate");
    }
  }
};
</script>

